import React from 'react';
import RecommendSearchWordDetailNavbar from '../RecommendSearchWordDetailNavbar';
import RecommendSearchWordDetailInfo from '../RecommendSearchWordDetailInfo';
import RecommendSearchWordDetailItemList from '../RecommendSearchWordDetailItemList';
import './RecommendSearchWordDetailWrap.scss';

const RecommendReviewDetailWrap = (props) => {
  const { recommendSearchWordDetail } = props;
  const { recommendSearchWordInfo, recommendSearchWordItemList } = recommendSearchWordDetail;

  return (
    <div className="recommend-search-word-detail-wrap">
      {/* 하단 네브바 */}
      <RecommendSearchWordDetailNavbar recommendSearchWordId={recommendSearchWordInfo.recommendSearchWordId} />

      {/* 추천 검색 키워드 정보 */}
      <RecommendSearchWordDetailInfo recommendSearchWordInfo={recommendSearchWordInfo} />

      {/* 추천 검색 키워드 아이템 리스트*/}
      <RecommendSearchWordDetailItemList recommendSearchWordItemList={recommendSearchWordItemList} />
    </div>
  );
};

export default RecommendReviewDetailWrap;
